import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteBlogs } from "../../api/apiBlogs";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي نهائي للمدونات
 */
export function useForceDeleteAllBlogs() {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllBlogsMutate,
        isPending,
    } = useMutation({
        mutationFn: massForceDeleteBlogs,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blogs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete blogs");
        },
    });

    return {
        forceDeleteAllBlogsMutate,
        isPending,
    };
}
